module.exports = __webpack_public_path__ + "static/scale-model-of-world-famous-giant-shoe-museum-in-seattle-washington-7936d54c681ccbf313081c4dba23919a.png";